(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeDetailController', PhoneCallPurposeDetailController);

    /* Added UIFormAccess
    PhoneCallPurposeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallPurpose'];

    function PhoneCallPurposeDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallPurpose) {
    */
    PhoneCallPurposeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCallPurpose', 'UIFormAccess'];

    function PhoneCallPurposeDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCallPurpose, UIFormAccess) {
        var vm = this;

        vm.phoneCallPurpose = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallPurposeUpdate', function(event, result) {
            vm.phoneCallPurpose = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
